export default __webpack_public_path__ + "static/media/abshar.fe3f2445.jpg";